import { makeStyles } from '@material-ui/core/styles'
import { useContext, useEffect, useState } from 'react'
import DataGridBase from '../../2compounds/DataGrid/DataGridBase'
import DataGridCardApproval from './DataGridCardApproval'
import { useNavigate, useParams } from 'react-router-dom'
import ApiService from '../../../common/ApiCalls'
import { getItemFromSessionStorage } from '../../../services/util/sessionStorageManager'
import { formatDate } from '../../../services/util/formatter'
import LoaderBackdrop from '../../2compounds/LoaderBackdrop'
import { FeedbackSnackbar } from '../../1elements'
import { GlobalContext } from '../../../services/context/DataContext'

const DataEntryCardApproval = ({
  heading,
  columns,
  setColumns,
  data,
  addMode,
  editMode,
  deleteMode,
  editable
}) => {
  const navigate = useNavigate()
  // Add, Edit, Delete Mode Management
  const dataEntryId = useParams().pendingDataId
  const [currentPage, setCurrentPage] = useState(1)
  const classes = useStyles({ editMode })
  const {
    dataManagementNotificationCount: dataManagementNotificationCountContext
  } = useContext(GlobalContext)
  const [, setDataManagementNotificationCount] =
    dataManagementNotificationCountContext

  const [rows, setRows] = useState([...data])
  const [approver, setApprover] = useState(null)

  const [loaderBackdrop, setLoaderBackdrop] = useState(false)
  const [snackbar, setSnackbar] = useState({
    severity: 'success',
    isOpen: false,
    message: 'The request has been approved.'
  })
  const hintIsActive = editMode || addMode

  const onReject = async reason => {
    setLoaderBackdrop(true)
    const initiatorEmail = getItemFromSessionStorage('initiatorEmail')
    await ApiService().rejectPendingDashboardData(
      dataEntryId,
      reason,
      initiatorEmail
    )
    setLoaderBackdrop(false)
    setSnackbar({
      severity: 'success',
      message: 'The request has been rejected.',
      isOpen: true
    })
    setTimeout(() => {
      navigate(-1)
    }, 1500)
  }

  const onApprove = async () => {
    try {
      setLoaderBackdrop(true)
      await ApiService().approvePendingDashboardData(dataEntryId)
      setLoaderBackdrop(false)
      setSnackbar({
        severity: 'success',
        message: 'The request has been approved.',
        isOpen: true
      })
      setTimeout(() => {
        setDataManagementNotificationCount(prevState => prevState - 1)
        navigate(-1)
      }, 1500)
    } catch (err) {
      setLoaderBackdrop(false)
      setSnackbar({
        severity: 'fail',
        message: err.response.data,
        isOpen: true
      })
    }
  }

  const reOpen = async () => {
    const locId = localStorage.getItem('locId')
    const userId = localStorage.getItem('userId')
    const initiatorEmail = localStorage.getItem('email')
    const {
      name,
      comment,
      type,
      date,
      complianceScore,
      incidents,
      inspectionScore,
      reports,
      satisfactionScore,
      originalDate
    } = rows[0]

    switch (heading) {
      case 'Dashboard Metrics':
        await ApiService().reOpenRejected(dataEntryId, null, {
          clientScore: satisfactionScore || '',
          inspectionScore: inspectionScore || '',
          complianceScore: complianceScore || '',
          reportCount: reports || '',
          incidentCount: incidents || '',
          id: locId,
          approver: approver.user_id,
          createdBy: userId,
          date: formatDate(date, 'YYYY-MM-DD'),
          initiatorEmail,
          isDateEdited: date !== originalDate
        })
        break
      case 'Comments':
        await ApiService().reOpenRejected(
          dataEntryId,
          {
            commenterName: name,
            comment: comment,
            commenterType: type,
            id: locId,
            createdBy: userId,
            approver: approver.user_id,
            date: formatDate(date, 'YYYY-MM-DD'),
            initiatorEmail,
            isDateEdited: date !== originalDate
          },
          null
        )
        break
      default:
    }
  }

  const onSubmit = async () => {
    try {
      setLoaderBackdrop(true)
      await reOpen()
      const data = { email: approver.email, name: approver.username }
      await ApiService().notifyApprover(data)
      setLoaderBackdrop(false)
      setSnackbar({
        severity: 'success',
        message: 'Your request has been sent.',
        isOpen: true
      })
      setTimeout(() => {
        navigate(-1)
      }, 1500)
    } catch (err) {
      setLoaderBackdrop(false)
      setSnackbar({
        severity: 'fail',
        message: err.response.data,
        isOpen: true
      })
    }
  }

  const onRowEditCommit = params => {
    const targetIndex = rows.findIndex(row => row.id === params.row.id)
    const rowsCopy = [...rows]
    rowsCopy[targetIndex] = params.row
    setRows(rowsCopy)
  }

  const onRowClick = (a, b) => {
    const clickEvent = new Event('dblclick', {
      bubbles: true,
      cancelable: false
    })
    const target2 = document.elementFromPoint(0, 0)
    target2.dispatchEvent(clickEvent)

    setTimeout(() => {
      const target = document.elementFromPoint(b.clientX, b.clientY)
      target.dispatchEvent(clickEvent)
    }, 100)
  }

  useEffect(() => {
    setRows([...data])
  }, [data])

  return (
    <>
      <DataGridCardApproval
        heading={heading}
        dataCount={data.length}
        editable={editable}
        approver={approver}
        setApprover={setApprover}
        onSubmit={onSubmit}
        addActive={addMode}
        editActive={editMode}
        deleteActive={deleteMode}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onReject={onReject}
        onApprove={onApprove}
        columns={columns}
        setColumns={setColumns}
      >
        <DataGridBase
          className={classes.dataGridBase}
          columns={columns}
          rows={rows}
          editable={editable}
          onRowClick={onRowClick}
          onRowEditCommit={onRowEditCommit}
          hint={hintIsActive}
        />
      </DataGridCardApproval>
      <LoaderBackdrop open={loaderBackdrop} />
      <FeedbackSnackbar snackbar={snackbar} setSnackbar={setSnackbar} />
    </>
  )
}

export default DataEntryCardApproval

const useStyles = makeStyles({
  // dataGridBase: {
  //     '& .MuiDataGrid-row:nth-child(2n-1)': {
  //         '& .MuiDataGrid-cellContent': {
  //             textDecoration: props => props.editMode && 'line-through'
  //         }
  //     },
  // }
})
